import { EscapeRoomDto, EscapeRoomHeaderDto, UpdateEscapeRoomRequestDto } from '../utils/types'
import apiClient from './api-client'

export const getEscapeRooms = async (): Promise<EscapeRoomHeaderDto[]> => {
    const res = await apiClient.get('/v1/escapeRooms')
    return res.data
}

export const createEscapeRoom = async (request: UpdateEscapeRoomRequestDto): Promise<EscapeRoomDto> => {
    const res = await apiClient.post('/v1/escapeRooms', request)
    return res.data
}

export const updateEscapeRoom = async (
    escapeRoomId: string, request: UpdateEscapeRoomRequestDto
): Promise<EscapeRoomDto> => {
    const res = await apiClient.put(`/v1/escapeRooms/${escapeRoomId}`, request)
    return res.data
}

export const deleteEscapeRoom = async (escapeRoomId: string) => {
    const res = await apiClient.delete(`/v1/escapeRooms/${escapeRoomId}`)
    return res.data
}

export const getEscapeRoom = async (escapeRoomId: string): Promise<EscapeRoomDto> => {
    const res = await apiClient.get(`/v1/escapeRooms/${escapeRoomId}`)
    return res.data
}
